<app-module-header [title]="$safeNavigationMigration(organization?.organizationName) + ' - Start'"
  [icon]="'home'"></app-module-header>

@if (isLoading) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="my-2">
  <div class="stats-grid">
    @if (organization?.config?.handleFlights) {
    <div class="stat-card" [ngClass]="problemFlightsNumber > 0 ? 'danger' : 'ok'" (click)="redirectToHandleFlights()">
      <div class="stat-icon"><mat-icon>flight_land</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.problemFlights | translateAttribute }}</div>
        <div class="stat-value">{{ problemFlightsNumber }}</div>
      </div>
    </div>
    }

    @if (organization?.config?.handleAdditionalServices) {
    <div class="stat-card" [ngClass]="unPlannedTaskNumber > 0 ? 'danger' : 'ok'"
      (click)="redirectToAdditionalServiceTasks()">
      <div class="stat-icon"><mat-icon>task</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.unplannedTasks | translateAttribute }}</div>
        <div class="stat-value">{{ unPlannedTaskNumber }}</div>
      </div>
    </div>
    }

    @if (organization?.config?.parkings?.length) {
    <div class="stat-card" [ngClass]="overlappingParkingsNumber > 0 ? 'danger' : 'ok'"
      (click)="redirectToOverlappingParkings()">
      <div class="stat-icon"><mat-icon>local_parking</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.problemParkings | translateAttribute }}</div>
        <div class="stat-value">{{ overlappingParkingsNumber }}</div>
      </div>
    </div>
    }

    @if (showProblemDevices) {
    <div class="stat-card" [ngClass]="problemDevicesNumber > 0 ? 'danger' : 'ok'" (click)="openProblemDevicesModal()">
      <div class="stat-icon"><mat-icon>sensors_off</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.problemDevices | translateAttribute }}</div>
        <div class="stat-value">{{ problemDevicesNumber }}</div>
      </div>
    </div>
    }

    <div class="stat-card" [ngClass]="problemOrdersNumber > 0 ? 'danger' : 'ok'" (click)="openProblemOrdersModal()">
      <div class="stat-icon"><mat-icon>receipt_long</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.problemOrders | translateAttribute }}</div>
        <div class="stat-value">{{ problemOrdersNumber }}</div>
      </div>
    </div>

    <div *ngIf="organization?.organizationId === flygetsOrganizationId" class="stat-card"
      [ngClass]="shuttlesNotInScheduleNumber > 0 ? 'danger' : 'ok'" (click)="redirectToShuttlesNotInSchedule()">
      <div class="stat-icon"><mat-icon>directions_bus</mat-icon></div>
      <div class="stat-content">
        <div class="stat-label">{{ i18n.problemShuttles | translateAttribute }}</div>
        <div class="stat-value">{{ shuttlesNotInScheduleNumber }}</div>
      </div>
    </div>
  </div>

  <div class="modules-grid">
    @for (module of organization?.config?.backOfficeModules; track module) {
    <!-- *ngIf="myConfigService.hasModuleAccess(module.name, organization, this.authService.isAdminOrSiteAdmin())" -->
    <div class="module-card" [routerLink]="[module.menu.route]">
      <div class="module-icon">
        <mat-icon>{{ module.menu.icon }}</mat-icon>
      </div>
      <h3 class="module-name">{{ module.menu.name | translateAttribute}}</h3>
    </div>
    }
  </div>
</div>
